import { Component, OnDestroy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AllRoomsPreview, RoomListService } from './room-list.service';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';

import { TranslatePipe } from '@ngx-translate/core';
import { FooterService } from '../../../../reusable-components/footer/footer.service';
import { combineLatest, Subscription } from 'rxjs';
import { MatStepperService } from '../../lead-task-services/mat-stepper.service';
import { LeadTaskService } from '../../lead-task.service';

@Component({
  selector: 'app-room-list',
  imports: [
    MatButton,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatIcon,
    TranslatePipe,
  ],
  templateUrl: './room-list.component.html',
  styleUrl: './room-list.component.scss',
  providers: [RoomListService],
})
export class RoomListComponent implements OnDestroy {
  allRoomsPreview: AllRoomsPreview;
  matStepperSubscription: Subscription;

  constructor(
    protected roomListService: RoomListService,
    protected leadTaskService: LeadTaskService,
    private footerService: FooterService,
    private matStepperService: MatStepperService,
  ) {
    this.allRoomsPreview = roomListService.getRoomListPreview();

    this.matStepperSubscription = this.getMatStepperSubscription();
  }

  deleteSelfCreatedRoom(id: string) {
    this.leadTaskService.deleteSelfCreatedRoom(id);
    this.allRoomsPreview = this.roomListService.getRoomListPreview();
  }

  getMatStepperSubscription(): Subscription {
    return combineLatest([
      this.matStepperService.currentStep$,
      this.roomListService.getNgComponentOutletInputObservable(),
    ]).subscribe(([currentIndex, ngComponentOutletInput]) => {
      if (
        currentIndex === 1 &&
        ngComponentOutletInput.component === RoomListComponent
      ) {
        this.footerService.setLeftButton(
          this.matStepperService.getPreviousButton(),
        );
        this.footerService.setRightButton(
          this.matStepperService.getNextButton(),
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.matStepperSubscription.unsubscribe();
  }
}
